import App from "../Core/App";

export default class EventSystem {
	constructor() {
		this._events 	= {};
	}

	on(title, handler = function(data){}) {
		if( !this._events.hasOwnProperty(title) ) {
			this._events[title] = [];
		}

		this._events[title].push(handler);
	}

	emit(title, data = []) {
		if( !this._events.hasOwnProperty(title) ) return;

		let count = 0;
		this._events[title].forEach(function(handler) {
			handler(data);
			count++;
		});

		App.getInstance().getLogger().debug("Emitted event \"" + title + "\" (called " + count + " handlers), attached parameters: ", data)
	}
}